angular.module('locationService', ['ui.router','constants'])
.factory('locationService', function($http, $q, $rootScope, myConfig) {

  var service = {};

  var _baseUrl = myConfig.apiUrl + 'rings/'; //'http://127.0.0.1:8000/v1/rings/';

    
  /*
  * get list of user locations
  */
  service.fetchUserLocations = function(additionalUrl){
    var tableName = 'userlocations';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    //var userId = $rootScope.user.UID;
    var url = _baseUrl + tableName;
    if (typeof additionalUrl !== 'undefined'){
      url += "?" + additionalUrl
    }
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
         
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * save location
  */
  service.saveUserLocation = function(dataToSend){
    var tableName = 'userlocations';
    var restMethod = ((!dataToSend.ID || dataToSend.ID == 0) ? 'POST' : 'PUT');
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    //var userId = $rootScope.user.UID;
    var url = _baseUrl + tableName;

    $http({
      method: restMethod,
      url: url,
      data: dataToSend,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
         
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

   /*
  * get list of rings for given user
  */
  service.deleteUserLocation = function(idVal){
    var tableName = 'userlocations';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName + '?id=' + idVal;
    
    $http({
      method: 'DELETE',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }


  return service;

});
